var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/client.ts
import Cookies from "universal-cookie";

// src/utils.ts
import { isRecordType } from "@karrotmarket-com/type-utility";
var REGION_COOKIE_KEY = "region";
var CONFIRM_COUNTRY_BANNER_COOKIE_KEY = "bn_check";
var isRegionValue = /* @__PURE__ */ __name((value) => {
  return isRecordType(value) && typeof value.regionId === "string" && typeof value.regionName === "string" && typeof value.countryCode === "string";
}, "isRegionValue");

// src/client.ts
var addOneYearFromToday = /* @__PURE__ */ __name(() => {
  const newDate = /* @__PURE__ */ new Date();
  newDate.setFullYear(newDate.getFullYear() + 1);
  return newDate;
}, "addOneYearFromToday");
var _BrowserRegionCookieStorage = class _BrowserRegionCookieStorage {
  cookie = new Cookies();
  static of() {
    return new _BrowserRegionCookieStorage();
  }
  get = /* @__PURE__ */ __name(async () => {
    const region = this.cookie.get(REGION_COOKIE_KEY);
    if (region == null) {
      return null;
    }
    if (isRegionValue(region)) {
      return region;
    }
    return null;
  }, "get");
  set = /* @__PURE__ */ __name(async ({
    regionId,
    regionName,
    countryCode
  }) => {
    this.cookie.set(
      REGION_COOKIE_KEY,
      JSON.stringify({
        regionId,
        regionName,
        countryCode
      }),
      {
        expires: addOneYearFromToday(),
        secure: false,
        path: "/",
        domain: window.location.hostname
      }
    );
  }, "set");
  update = /* @__PURE__ */ __name(async (args) => {
    this.cookie.remove(REGION_COOKIE_KEY);
    this.set(args);
  }, "update");
};
__name(_BrowserRegionCookieStorage, "BrowserRegionCookieStorage");
var BrowserRegionCookieStorage = _BrowserRegionCookieStorage;
var _BrowserConfirmCountryBannerCookieStorage = class _BrowserConfirmCountryBannerCookieStorage {
  cookie = new Cookies();
  static of() {
    return new _BrowserConfirmCountryBannerCookieStorage();
  }
  get = /* @__PURE__ */ __name(async () => {
    const confirmCookie = this.cookie.get(CONFIRM_COUNTRY_BANNER_COOKIE_KEY);
    if (!confirmCookie) {
      return null;
    }
    return confirmCookie;
  }, "get");
  set = /* @__PURE__ */ __name(async ({ disabled }) => {
    this.cookie.set(
      CONFIRM_COUNTRY_BANNER_COOKIE_KEY,
      JSON.stringify({ disabled }),
      {
        expires: addOneYearFromToday(),
        secure: false,
        path: "/",
        domain: window.location.hostname
      }
    );
  }, "set");
  update = /* @__PURE__ */ __name(async (args) => {
    this.cookie.remove(CONFIRM_COUNTRY_BANNER_COOKIE_KEY);
    this.set(args);
  }, "update");
};
__name(_BrowserConfirmCountryBannerCookieStorage, "BrowserConfirmCountryBannerCookieStorage");
var BrowserConfirmCountryBannerCookieStorage = _BrowserConfirmCountryBannerCookieStorage;
export {
  BrowserConfirmCountryBannerCookieStorage,
  BrowserRegionCookieStorage
};
/*! For license information please see client.mjs.LEGAL.txt */
//# sourceMappingURL=client.mjs.map
